export default __webpack_public_path__ + "static/media/kidsMobile.337e64ff.jpg";